import { ChannelTypeEnum, VerifyVerificationCodeData } from "../../types";
import EventBus from "../event-bus";
const verifyVerificationCodeHook = new EventBus<{
  channelType: ChannelTypeEnum;
  data: VerifyVerificationCodeData;
}>("verifyVerificationCodeHook");

export default verifyVerificationCodeHook;
